import React from 'react'
import { useNavigate } from "react-router-dom"

const NavPaneTile = ({ name, link, icon, color, activePage }) => {
  const navigate = useNavigate()

  // STRICT CHECK: Only external URLs or explicit .html files trigger a hard browser navigation
  const isSitePage = 
    link?.startsWith('http://') || 
    link?.startsWith('https://') || 
    link?.endsWith('.html') || 
    link?.startsWith('../')

  const navigateTo = () => {
    if (!link) return

    if (isSitePage) {
      // Hard redirect ONLY for the "Site Pages" section (index.html, feed.html, chat.html, etc.)
      window.location.href = link
    } else {
      // 100% internal React Router SPA navigation for everything else (Home, Recent, Liked, Categories)
      navigate(link)
    }
  }

  return (
    <button 
      className={"w-full flex h-10 p-2 rounded-lg transition-colors hover:bg-white/10 " + (activePage === name ? "ring-2 ring-gray-400 bg-white/10" : "")} 
      onClick={navigateTo}
    >
      <div className={"text-lg w-1/8 pr-10 " + color}>
        <i className={icon}></i>
      </div>
      <div className="flex-1 text-left text-white">
        {name}
      </div>
    </button>
  )
}

export default NavPaneTile
